import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Paper,
  Typography,
  Button,
  Modal,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import axios from "axios";
import { localeTextVietnamese } from "../../utils/localeText-vn";
import { generateSlug } from "../../utils/CurrencyFormat";
import { toast } from "react-toastify";
import swal from "sweetalert";

const paginationModel = { page: 1, pageSize: 10 };

export default function CategoryPage() {
  const [rows, setRows] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [images, setImages] = React.useState([]);
  const [formData, setFormData] = React.useState({
    name: ``,
    slug: ``,
    image: ``,
    isNavbar: false,
    isPopular: false,
    isHot: false,
    parentId: 0,
  });
  const [errors, setErrors] = React.useState({});

  // setting collumn
  const columns = [
    { field: "index", headerName: "STT", width: 100 },
    { field: "name", headerName: "Tên danh mục", flex: 3 },
    { field: "slug", headerName: "Slug", flex: 3 },
    {
      field: "image",
      headerName: "Hình ảnh",
      flex: 3,
      renderCell: (params) => (
        <Box
          component="img"
          sx={{
            width: 230,
            height: 130,
            objectFit: "cover",
            borderRadius: "8px",
          }}
          alt={params.row.title}
          src={params.value}
        />
      ),
    },
    { field: "parentName", headerName: "Danh mục cha", flex: 3 },
    {
      field: "isNavbar",
      headerName: "Điều hướng",
      flex: 1,
      renderCell: (params) => <>{params.value ? "Có" : "Không"}</>,
    },
    {
      field: "isPopular",
      headerName: "Nổi bật",
      flex: 1,
      renderCell: (params) => <>{params.value ? "Có" : "Không"}</>,
    },
    {
      field: "isHot",
      headerName: "Hot",
      flex: 1,
      renderCell: (params) => <>{params.value ? "Có" : "Không"}</>,
    },
    {
      field: "action",
      headerName: "Thao tác",
      description: "",
      sortable: false,
      flex: 3,
      renderCell: (params) => (
        <Box
          sx={{ display: "flex", gap: 1, alignItems: "center", height: "100%" }}
        >
          <Button
            variant="contained"
            color="warning"
            onClick={(event) => {
              event.stopPropagation();
              handleEdit(params.row);
            }}
          >
            Chỉnh sửa
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={(event) => {
              event.stopPropagation();
              handleDelete(params.id);
            }}
          >
            Xoá
          </Button>
        </Box>
      ),
    },
  ];

  const handleEdit = (row) => {
    handleOpen(row);
  };

  React.useEffect(() => {
    getData();
    getImage();
  }, []);

  const getData = () => {
    axios
      .get(`/api/v1/categories`, {
        params: {},
      })
      .then((res) => {
        setRows(res.data.categories);
      })
      .catch((err) => console.log(err));
  };

  const getImage = () => {
    axios
      .get(`/api/v1/images`, {
        params: {},
      })
      .then((res) => {
        setImages(res.data.images);
      })
      .catch((err) => console.log(err));
  };

  const rowsWithIndex = rows.map((row, index) => ({
    index: index + 1,
    ...row,
    parentId: row.parentId == 0 ? "" : row.parentId,
  }));

  const handleOpen = (data) => {
    setOpen(true);
    if (data) {
      setFormData(data);
    }
  };

  const handleClose = (isReload) => {
    setOpen(!open);
    setFormData({});
    setErrors({});
    if (isReload) {
      getData();
    }
  };

  const handleSelectChange = (e) => {
    setFormData({
      ...formData,
      parentId: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = await validateForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      const sendData = {
        name: formData.name,
        slug: formData.slug,
        image: formData.image,
        isNavbar: formData.isNavbar,
        isPopular: formData.isPopular,
        isHot: formData.isHot,
        parentId: parseInt(formData.parentId, 10) || 0,
      };
      axios
        .post(`/api/v1/categories`, sendData)
        .then((res) => {
          toast("Thêm danh mục thành công!", {
            type: "success",
            autoClose: 1000,
          });
          handleClose(true);
        })
        .catch((err) => {
          console.log(err);
          toast(err.response.data.errors[0].msg, {
            type: "error",
            autoClose: 1000,
          });
        });
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const validationErrors = await validateForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      const sendData = {
        name: formData.name,
        slug: formData.slug,
        image: formData.image,
        isNavbar: formData.isNavbar,
        isPopular: formData.isPopular,
        isHot: formData.isHot,
        parentId: parseInt(formData.parentId, 10) || 0,
      };
      axios
        .put(`/api/v1/categories/` + formData.id, sendData)
        .then((res) => {
          toast("Cập nhật danh mục thành công!", {
            type: "success",
            autoClose: 1000,
          });
          handleClose(true);
        })
        .catch((err) => {
          console.log(err);
          toast("Có lỗi xảy ra!", {
            type: "error",
            autoClose: 1000,
          });
        });
    }
  };

  const validateForm = async (data) => {
    const errors = {};

    if (!data.name || data.name.trim() === "") {
      errors.name = "Tên danh mục không được để trống.";
    }

    if (!data.slug || data.slug.trim() === "") {
      errors.slug = "Slug danh mục không được để trống.";
    }

    return errors;
  };

  const handleDelete = (id) => {
    swal({
      title: `Bạn muốn xóa danh mục này`,
      text: ` Lưu ý: Hành động không thể khôi phục lại`,
      icon: "warning",
      buttons: ["Đóng", "Xóa"],
      successMode: true,
    }).then((ok) => {
      if (ok) {
        axios
          .delete(`/api/v1/categories/${id}`)
          .then((res) => {
            toast("Xoá danh mục thành công", {
              type: "success",
              autoClose: 1000,
            });
            getData();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const handleSelectChangeImage = (e) => {
    setErrors({ ...errors, image: "" });
    setFormData({
      ...formData,
      image: e.target.value,
    });
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Quản lý danh mục
      </Typography>
      <Box sx={{ marginBottom: 2, display: "flex", justifyContent: "end" }}>
        <Button
          variant="contained"
          color="info"
          sx={{ width: 100 }}
          onClick={handleOpen}
        >
          Thêm
        </Button>
      </Box>
      <Paper sx={{ height: 730, width: "100%" }}>
        <DataGrid
          rows={rowsWithIndex}
          rowHeight={150}
          columns={columns}
          initialState={{ pagination: { paginationModel } }}
          pageSizeOptions={[5, 10]}
          // checkboxSelection
          disableRowSelectionOnClick
          localeText={localeTextVietnamese}
          sx={{
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
              outline: "none",
            },
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
              {
                marginBottom: 0,
              },
          }}
        />
      </Paper>
      {/* Add Edit Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Paper
            sx={{
              width: 600,
              p: 5,
              height: "95vh",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <Typography sx={{ pb: 5 }} variant="h4" component="h2">
              {formData.id ? "Sửa" : "Thêm"} danh mục
            </Typography>
            <TextField
              label="Tên danh mục"
              required
              variant="outlined"
              sx={{ width: "100%", paddingBottom: 5 }}
              value={formData.name ?? ""}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  name: e.target.value,
                  slug: generateSlug(e.target.value),
                });
                setErrors({ ...errors, name: "", slug: "" });
              }}
              error={Boolean(errors.name)}
              helperText={errors.name}
            />
            <TextField
              label="Slug"
              required
              variant="outlined"
              sx={{ width: "100%", paddingBottom: 5 }}
              value={formData.slug ?? ""}
              onChange={(e) => {
                setFormData({ ...formData, slug: e.target.value });
                setErrors({ ...errors, slug: "" });
              }}
              error={Boolean(errors.slug)}
              helperText={errors.slug}
            />
            {formData.image ? (
              <Box
                component="img"
                sx={{
                  width: 300,
                  height: 200,
                  objectFit: "cover",
                  borderRadius: "8px",
                  mb: 2,
                }}
                alt={formData.title}
                src={formData.image}
              />
            ) : (
              <Box sx={{ mb: 2 }}>Hình ảnh danh mục trống</Box>
            )}
            <FormControl fullWidth sx={{ pb: 5 }}>
              <InputLabel id="image-label" error={Boolean(errors.image)}>
                Chọn hình ảnh
              </InputLabel>
              <Select
                labelId="image-label"
                value={formData.image ?? ``}
                onChange={handleSelectChangeImage}
                label="Chọn hình ảnh *"
                error={Boolean(errors.image)}
              >
                {images.map((item, idx) => (
                  <MenuItem key={idx} value={item.path}>
                    {item.path}
                  </MenuItem>
                ))}
              </Select>
              {errors.image && (
                <p className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-contained Mui-required css-er619e-MuiFormHelperText-root">
                  {errors.image}
                </p>
              )}
            </FormControl>
            <FormControl fullWidth sx={{ pb: 5 }}>
              <InputLabel id="category-label">Chọn danh mục cha</InputLabel>
              <Select
                labelId="category-label"
                value={formData.parentId ?? ``}
                onChange={handleSelectChange}
                label="Chọn danh mục cha"
              >
                {rows.map((item, idx) => (
                  <MenuItem key={idx} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.isNavbar}
                  onChange={(e) =>
                    setFormData({ ...formData, isNavbar: e.target.checked })
                  }
                />
              }
              label="Điều hướng"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.isPopular}
                  onChange={(e) =>
                    setFormData({ ...formData, isPopular: e.target.checked })
                  }
                />
              }
              label="Danh mục nổi bật"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.isHot}
                  onChange={(e) =>
                    setFormData({ ...formData, isHot: e.target.checked })
                  }
                />
              }
              label="Danh mục HOT"
            />
            <Box sx={{ display: "flex", justifyContent: "end", gap: 3, pt: 2 }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleClose}
              >
                Trở về
              </Button>
              <Button
                variant="contained"
                color="info"
                onClick={formData.id ? handleUpdate : handleSubmit}
              >
                Lưu
              </Button>
            </Box>
          </Paper>
        </Box>
      </Modal>

      {/* Delete Modal */}
    </Box>
  );
}
